export default "/_next/static/chunks/fonts/HK Grotesk Black Italic-848b4b40a67b759028a64b4e4c5d4d8a.otf";